import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import ArticlePreview from '../articlePreview';
import getCitedByProcessor from '../../../utils/citedBy/getCitedByProcessor';
import createArticleEvents from '../../../utils/trackers/createArticleEvents';

const getIndex = (state, { panel: { launchProps: { index } } }) => index;
const getIdType = ({ idType }) => idType;
const getCitingArticles = ({ citingArticles }) => citingArticles;

export const mapStateToProps = createSelector(
  [getIndex, getIdType, getCitingArticles],
  (index, idType, citingArticles) => {
    const processor = getCitedByProcessor(idType);
    const articlePreviewProps = processor.createArticleProps(citingArticles, index);

    const { documentSubtype, pii, doi } = articlePreviewProps;

    const eventDataProps = createArticleEvents(
      'article-preview-citedby',
      { documentSubtype },
      { pii, doi },
    );

    return {
      ...articlePreviewProps,
      eventData: eventDataProps,
    };
  },
);

export default connect(mapStateToProps)(ArticlePreview);
